module.exports = __webpack_public_path__ + "static/media/strategy-1.9e9d65bd.jpg";